// get a bfs order for tree, and add level for each tree node
// i.e root is level 0, root's children are level 2, root's children's children are level 3...
export const bfsSearch = (root, nodeList, level) => {
  if (!root.level) {
    root.level = level;
  }
  nodeList.push(root);
  root.descendants.forEach(d => {
      bfsSearch(d, nodeList, root.level+1);
  });
}